import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { wakeUpServer } from '../store/serverSlice';

// Full-screen prikaz dok se server pokreće (Render free plan)
function ServerWakeUp() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const status = useSelector((state) => state.serverStore.status);
    const isSlow = useSelector((state) => state.serverStore.isSlow);

    return (
        <div className="min-h-screen bg-gradient-to-br from-cyan-200 via-white to-pink-300 flex flex-col items-center justify-center px-6 text-center">
            <img src="/logo2.png" className="w-16 h-16 mb-6" alt="Weddinfy" />

            {status === 'error' ? (
                <>
                    <p className="text-gray-800 text-lg max-w-md">{t('server.error')}</p>
                    <button type="button" onClick={() => dispatch(wakeUpServer())} className="submitButton px-8 mt-6 mx-auto">
                        {t('server.retry')}
                    </button>
                </>
            ) : (
                <>
                    <div className="w-10 h-10 border-4 border-rose-200 border-t-rose-500 rounded-full animate-spin" role="status" />
                    <p className="text-gray-800 text-lg mt-6 max-w-md">{t('server.starting')}</p>
                    {isSlow && <p className="text-gray-600 text-sm mt-2 max-w-md">{t('server.slow')}</p>}
                </>
            )}
        </div>
    );
}

export default ServerWakeUp;
